import './styles/core.scss'
import 'react-dates/initialize'
import './utils/polyfill'
import { version } from '../package.json'
import Pusher from 'pusher-js'
import { render } from 'react-dom'
import configureStore from './store/configureStore'
import { hideModal } from './actions/_modal'
import { loginUserSuccess } from './actions/auth'
import { getPusherApiKey } from './utils'
import Root from './containers/Root'

const { store, history } = configureStore()

let token = sessionStorage.getItem('token')
if (token !== null) {
  store.dispatch(loginUserSuccess(token))
}

// if user refreshes, they may have a modal open in state
store.dispatch(hideModal())

// open a Pusher connection
window.oeQwPusherInstance = new Pusher(getPusherApiKey(), {
  cluster: 'mt1'
})

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('oe-ts')
    window.removeEventListener('keydown', handleFirstTab)
  }
}

window.addEventListener('keydown', handleFirstTab)
document.getElementById('appVersion').innerHTML = version

render(
  <Root store={store} history={history} />,
  document.getElementById('root')
)
